; (() => {
    const focusedClass = 'control-wrapper_focused'
    const hoveredClass = 'control-wrapper_hovered'

    {
        document.querySelectorAll('.control-wrapper_outlined').forEach(el => {
            if (!el) return
            const input = el.querySelector('input')

            el.addEventListener('mouseover', () => el.classList.add(hoveredClass))
            el.addEventListener('mouseout', () => el.classList.remove(hoveredClass))

            if (input) {
                input.addEventListener('focus', () => el.classList.add(focusedClass))
                input.addEventListener('blur', () => el.classList.remove(focusedClass))
            }
        })
    }

    {
        const errorClass = 'control-wrapper-v2_error'

        document.querySelectorAll('.control-wrapper-v2_outlined').forEach(el => {
            if (!el) return
            const input = el.querySelector('input')

            el.addEventListener('mouseover', () => el.classList.add(hoveredClass))
            el.addEventListener('mouseout', () => el.classList.remove(hoveredClass))

            if (input) {
                input.addEventListener('focus', () => el.classList.add(focusedClass))
                input.addEventListener('blur', () => el.classList.remove(focusedClass))
                input.addEventListener('input', () => el.classList.remove(errorClass))
            }
        })
    }

})()
